import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import { App } from "./App";
import "./styles.css";
const root = document.getElementById("root");
if (!root) {
    throw new Error("Gallery root element was not found.");
}
createRoot(root).render(_jsx(App, {}));
